import { useGetTppImpactMetricsQuery } from '../../../../shared/queries/metrics/useGetTppImpactMetricsQuery'

const useTppImpactMetrics = () => {
    const getTppImpactMetricsQuery = useGetTppImpactMetricsQuery()

    const filteredCards = getTppImpactMetricsQuery.data?.filter((card) => !!card.items.length) || []

    return {
        cards: filteredCards,
        isLoading: getTppImpactMetricsQuery.isLoading,
    }
}

export default useTppImpactMetrics
